import {useContext} from 'react';
import {Context} from '../context';

export function useCartCount() {
  const {cart} = useContext(Context);
  if (cart == null || cart.totalQuantity == null) {
    return 0;
  }

  return cart.totalQuantity;
}